// 2026-10-27 오너 — "문의 지역 구분은 자동ib의 지역2를 기준으로 해야된다. 영어로 적어서 오는거는 알아서 잘
// 넣어줘야되고". 문의 탭(같은 날 오너 "수기 탭으로 바꾸자" — 도입문의 현황 수기 탭)의 지역2 칸에는 '강남구', '수원시', '해운대구'처럼 시군구가 적혀 오고, 가끔
// 'Gangnam-gu', 'Suwon' 처럼 영어로 오거나 해외 지명이 온다. 그 글자를 시도('서울', '경기' …) · '해외'로 바꾼다.
//
// 정하는 차례
//   1. 시군구 이름(접미사까지) 그대로 — '광주시'는 경기 광주시, '고성군'은 강원 · 경남 둘 다라 모호.
//   2. 시도 이름('서울', '경상북도', 'Seoul', 'Gyeonggi-do' …).
//   3. 접미사를 뗀 시군구 이름('강남', '수원') · 로마자 시군구 이름('Haeundae').
//   4. 모호하면(중구 · 동구 · 고성군 …) 지역1 같은 다른 칸의 시도로 고른다. 그래도 모르면 null.
//   5. 한글이 하나도 없고 국내 지명과도 맞지 않으면 '해외'(영어로 적힌 해외 문의).
import { toBusinessSido } from './business-regions.js';
/** 시도 → 그 시도의 시군구(구 단위 포함). 2024년 행정구역 기준. */
const SIGUNGU = {
    서울: [
        '종로구',
        '중구',
        '용산구',
        '성동구',
        '광진구',
        '동대문구',
        '중랑구',
        '성북구',
        '강북구',
        '도봉구',
        '노원구',
        '은평구',
        '서대문구',
        '마포구',
        '양천구',
        '강서구',
        '구로구',
        '금천구',
        '영등포구',
        '동작구',
        '관악구',
        '서초구',
        '강남구',
        '송파구',
        '강동구',
    ],
    부산: [
        '중구',
        '서구',
        '동구',
        '영도구',
        '부산진구',
        '동래구',
        '남구',
        '북구',
        '해운대구',
        '사하구',
        '금정구',
        '강서구',
        '연제구',
        '수영구',
        '사상구',
        '기장군',
    ],
    대구: ['중구', '동구', '서구', '남구', '북구', '수성구', '달서구', '달성군', '군위군'],
    인천: [
        '중구',
        '동구',
        '미추홀구',
        '연수구',
        '남동구',
        '부평구',
        '계양구',
        '서구',
        '강화군',
        '옹진군',
    ],
    광주: ['동구', '서구', '남구', '북구', '광산구'],
    대전: ['동구', '중구', '서구', '유성구', '대덕구'],
    울산: ['중구', '남구', '동구', '북구', '울주군'],
    세종: ['세종시'],
    경기: [
        '수원시',
        '성남시',
        '의정부시',
        '안양시',
        '부천시',
        '광명시',
        '평택시',
        '동두천시',
        '안산시',
        '고양시',
        '과천시',
        '구리시',
        '남양주시',
        '오산시',
        '시흥시',
        '군포시',
        '의왕시',
        '하남시',
        '용인시',
        '파주시',
        '이천시',
        '안성시',
        '김포시',
        '화성시',
        '광주시',
        '양주시',
        '포천시',
        '여주시',
        '연천군',
        '가평군',
        '양평군',
        // 일반구와 흔히 쓰는 동네 이름
        '장안구',
        '권선구',
        '팔달구',
        '영통구',
        '수정구',
        '중원구',
        '분당구',
        '만안구',
        '동안구',
        '상록구',
        '단원구',
        '덕양구',
        '일산동구',
        '일산서구',
        '처인구',
        '기흥구',
        '수지구',
        '원미구',
        '소사구',
        '오정구',
        '분당',
        '일산',
        '판교',
        '동탄',
        '광교',
        '평촌',
        '산본',
    ],
    강원: [
        '춘천시',
        '원주시',
        '강릉시',
        '동해시',
        '태백시',
        '속초시',
        '삼척시',
        '홍천군',
        '횡성군',
        '영월군',
        '평창군',
        '정선군',
        '철원군',
        '화천군',
        '양구군',
        '인제군',
        '고성군',
        '양양군',
    ],
    충북: [
        '청주시',
        '충주시',
        '제천시',
        '보은군',
        '옥천군',
        '영동군',
        '증평군',
        '진천군',
        '괴산군',
        '음성군',
        '단양군',
        '상당구',
        '서원구',
        '흥덕구',
        '청원구',
    ],
    충남: [
        '천안시',
        '공주시',
        '보령시',
        '아산시',
        '서산시',
        '논산시',
        '계룡시',
        '당진시',
        '금산군',
        '부여군',
        '서천군',
        '청양군',
        '홍성군',
        '예산군',
        '태안군',
        '동남구',
        '서북구',
    ],
    전북: [
        '전주시',
        '군산시',
        '익산시',
        '정읍시',
        '남원시',
        '김제시',
        '완주군',
        '진안군',
        '무주군',
        '장수군',
        '임실군',
        '순창군',
        '고창군',
        '부안군',
        '완산구',
        '덕진구',
    ],
    전남: [
        '목포시',
        '여수시',
        '순천시',
        '나주시',
        '광양시',
        '담양군',
        '곡성군',
        '구례군',
        '고흥군',
        '보성군',
        '화순군',
        '장흥군',
        '강진군',
        '해남군',
        '영암군',
        '무안군',
        '함평군',
        '영광군',
        '장성군',
        '완도군',
        '진도군',
        '신안군',
    ],
    경북: [
        '포항시',
        '경주시',
        '김천시',
        '안동시',
        '구미시',
        '영주시',
        '영천시',
        '상주시',
        '문경시',
        '경산시',
        '의성군',
        '청송군',
        '영양군',
        '영덕군',
        '청도군',
        '고령군',
        '성주군',
        '칠곡군',
        '예천군',
        '봉화군',
        '울진군',
        '울릉군',
    ],
    경남: [
        '창원시',
        '진주시',
        '통영시',
        '사천시',
        '김해시',
        '밀양시',
        '거제시',
        '양산시',
        '의령군',
        '함안군',
        '창녕군',
        '고성군',
        '남해군',
        '하동군',
        '산청군',
        '함양군',
        '거창군',
        '합천군',
        '의창구',
        '성산구',
        '마산합포구',
        '마산회원구',
        '진해구',
        '마산',
        '진해',
    ],
    제주: ['제주시', '서귀포시'],
};
/** 영어 시도 이름(소문자, 글자만 남긴 꼴에서 찾는다). */
const EN_SIDO = [
    [/seoul/, '서울'],
    [/busan|pusan/, '부산'],
    [/daegu|taegu/, '대구'],
    [/incheon|inchon/, '인천'],
    [/gwangju|kwangju/, '광주'],
    [/daejeon|taejon|daejon/, '대전'],
    [/ulsan/, '울산'],
    [/sejong/, '세종'],
    [/gyeonggi|kyonggi|gyunggi/, '경기'],
    [/gangwon|kangwon/, '강원'],
    [/chungcheongbuk|chungbuk|northchungcheong|chungcheongnorth/, '충북'],
    [/chungcheongnam|chungnam|southchungcheong|chungcheongsouth/, '충남'],
    [/jeollabuk|jeonbuk|chonbuk|northjeolla|jeollanorth|chollabuk/, '전북'],
    [/jeollanam|jeonnam|chonnam|southjeolla|jeollasouth|chollanam/, '전남'],
    [/gyeongsangbuk|gyeongbuk|kyongbuk|northgyeongsang|gyeongsangnorth|kyongsangbuk/, '경북'],
    [/gyeongsangnam|gyeongnam|kyongnam|southgyeongsang|gyeongsangsouth|kyongsangnam/, '경남'],
    [/jeju|cheju/, '제주'],
];
const NOT_A_PLACE = /^(n\/?a|none|null|unknown|tbd|tba|etc|test|미정|-)$/i;
const SUFFIX = /(특별자치시|특별자치도|특별시|광역시|시|군|구)$/;
// ── 국어의 로마자 표기법(간이) ──
const INITIAL = [
    'g',
    'kk',
    'n',
    'd',
    'tt',
    'r',
    'm',
    'b',
    'pp',
    's',
    'ss',
    '',
    'j',
    'jj',
    'ch',
    'k',
    't',
    'p',
    'h',
];
const MEDIAL = [
    'a',
    'ae',
    'ya',
    'yae',
    'eo',
    'e',
    'yeo',
    'ye',
    'o',
    'wa',
    'wae',
    'oe',
    'yo',
    'u',
    'wo',
    'we',
    'wi',
    'yu',
    'eu',
    'ui',
    'i',
];
// 받침 — 뒤 글자가 ㅇ 이면 넘어가서 읽는 꼴(LIAISON), 아니면 끝소리(FINAL).
const FINAL = [
    '',
    'k',
    'k',
    'k',
    'n',
    'n',
    'n',
    't',
    'l',
    'k',
    'm',
    'l',
    'l',
    'l',
    'p',
    'l',
    'm',
    'p',
    'p',
    't',
    't',
    'ng',
    't',
    't',
    'k',
    't',
    'p',
    't',
];
const LIAISON = [
    '',
    'g',
    'kk',
    'ks',
    'n',
    'nj',
    'n',
    'd',
    'r',
    'lg',
    'lm',
    'lb',
    'ls',
    'lt',
    'lp',
    'r',
    'm',
    'b',
    'ps',
    's',
    'ss',
    'ng',
    'j',
    'ch',
    'k',
    't',
    'p',
    '',
];
function romanize(hangul) {
    const syl = [...hangul]
        .map((ch) => ch.charCodeAt(0) - 0xac00)
        .filter((c) => c >= 0 && c < 11172)
        .map((c) => ({ i: Math.floor(c / 588), m: Math.floor((c % 588) / 28), f: c % 28 }));
    let out = '';
    syl.forEach((s, k) => {
        const next = syl[k + 1];
        let ini = INITIAL[s.i];
        const prev = syl[k - 1];
        if (prev && s.i === 11 && prev.f !== 0 && prev.f !== 21)
            ini = ''; // 앞 받침이 넘어왔다
        // ㅇ · ㅁ 받침 뒤의 ㄹ 은 ㄴ 으로 읽는다(종로 Jongno, 강릉 Gangneung).
        if (prev && s.i === 5 && (prev.f === 21 || prev.f === 16))
            ini = 'n';
        let fin = FINAL[s.f];
        if (next && next.i === 11 && s.f !== 0 && s.f !== 21)
            fin = LIAISON[s.f];
        out += ini + MEDIAL[s.m] + fin;
    });
    return out;
}
/**
 * 로마자 비교용으로 접는다 — 표기법마다 다른 곳(eo/u, k/g, l/r/n, ch/j …)을 한 꼴로 모은다.
 * 'Pusan' 과 'Busan', 'Jongno' 와 'Jongro' 가 같은 꼴이 된다.
 */
function fold(s) {
    return s
        .toLowerCase()
        .replace(/[^a-z]/g, '')
        .replace(/yeo/g, 'yo')
        .replace(/eo/g, 'o')
        .replace(/eu/g, 'u')
        .replace(/ae/g, 'e')
        .replace(/oe/g, 'e')
        .replace(/wo/g, 'o')
        .replace(/(kk|k)/g, 'g')
        .replace(/(tt|t)/g, 'd')
        .replace(/(pp|p)/g, 'b')
        .replace(/ss/g, 's')
        .replace(/(jj|ch|j)/g, 'j')
        .replace(/[lr]/g, 'n')
        .replace(/(.)\1+/g, '$1');
}
const EN_STOP = new Set([
    'si',
    'gu',
    'gun',
    'do',
    'city',
    'county',
    'district',
    'province',
    'metropolitan',
    'special',
    'self',
    'governing',
    'selfgoverning',
    'korea',
    'republic',
    'of',
    'the',
    'south',
    'north',
]);
// 이름 → 그 이름을 가진 시도들. 접미사 붙은 꼴, 뗀 꼴, 로마자 꼴 세 가지.
const BY_FULL = new Map();
const BY_BASE = new Map();
const BY_ROMAN = new Map();
function add(map, key, sido) {
    if (!key)
        return;
    const set = map.get(key) ?? new Set();
    set.add(sido);
    map.set(key, set);
}
for (const [sido, names] of Object.entries(SIGUNGU)) {
    for (const name of names) {
        add(BY_FULL, name, sido);
        const base = name.replace(SUFFIX, '');
        // '중' · '동' 처럼 한 글자로 남으면 너무 흔하다 — 뗀 꼴로는 찾지 않는다.
        if (base.length >= 2) {
            add(BY_BASE, base, sido);
            add(BY_ROMAN, fold(romanize(base)), sido);
        }
    }
}
function pick(cands, hint) {
    if (!cands || cands.size === 0)
        return null;
    if (cands.size === 1)
        return [...cands][0];
    if (hint && cands.has(hint))
        return hint;
    return 'ambiguous';
}
/**
 * 지역 글자(시군구 · 시도 · 영어 · 해외 지명) → 시도 · '해외' · null.
 * `hint` 는 같은 줄의 다른 지역 칸(지역1 등) — 모호한 시군구를 고를 때 쓴다.
 */
export function placeToBusinessSido(text, hint) {
    const s = (text ?? '').trim();
    const hintSido = toBusinessSido(hint) ?? englishSido(hint);
    if (!s || s === '-')
        return hintSido;
    let ambiguous = false;
    const tokens = s.split(/[\s,/·()]+/).filter(Boolean);
    // 1. 시군구 이름 그대로
    for (const t of tokens) {
        const r = pick(BY_FULL.get(t), hintSido);
        if (r === 'ambiguous')
            ambiguous = true;
        else if (r)
            return r;
    }
    // 2. 시도 이름
    const sido = toBusinessSido(s) ?? englishSido(s);
    if (sido)
        return sido;
    for (const t of tokens) {
        const r = toBusinessSido(t);
        if (r)
            return r;
    }
    // 3. 접미사 뗀 이름 · 로마자 이름
    for (const t of tokens) {
        // '판교동', '동탄읍'처럼 동 · 읍 · 면으로 적은 것도 그 앞 이름으로 찾는다.
        const r = pick(BY_BASE.get(t.replace(SUFFIX, '').replace(/(동|읍|면|리)$/, '')) ??
            BY_BASE.get(t.replace(SUFFIX, '')), hintSido);
        if (r === 'ambiguous')
            ambiguous = true;
        else if (r)
            return r;
    }
    if (!/[가-힣]/.test(s)) {
        const words = s
            .toLowerCase()
            .split(/[^a-z]+/)
            .filter((w) => w && !EN_STOP.has(w));
        for (const w of words) {
            const stripped = w.replace(/(gun|gu|si)$/, '');
            for (const cand of [w, stripped]) {
                if (cand.length < 3)
                    continue;
                const r = pick(BY_ROMAN.get(fold(cand)), hintSido);
                if (r === 'ambiguous')
                    ambiguous = true;
                else if (r)
                    return r;
            }
        }
    }
    // 4. 모호하면 다른 칸의 시도
    if (ambiguous || hintSido)
        return hintSido;
    // 5. 한글 없는 낯선 지명은 해외 문의 — 'N/A', 'TBD' 같은 빈칸 표시는 빼고.
    if (!/[가-힣]/.test(s) && /[a-z]{3,}/i.test(s) && !NOT_A_PLACE.test(s))
        return '해외';
    return null;
}
function englishSido(text) {
    const s = (text ?? '').toLowerCase().replace(/[^a-z]/g, '');
    if (!s)
        return null;
    for (const [re, sido] of EN_SIDO)
        if (re.test(s))
            return sido;
    return null;
}
//# sourceMappingURL=korea-places.js.map